import { green, red } from '@ant-design/colors'
import { Button, Col, Form, Row } from 'antd'
import { useContext, useState } from 'react'
import { AuthenticationContext } from '../../AuthenticationContext'
import VSpace from '../common/VSpace'
import RemoveUserModal from './RemoveUserModal'
import RestoreUserModal from './RestoreUserModal'
import PasswordUpdateSection from './UserFormSections/PasswordUpdateSection'
import SuperUserSection from './UserFormSections/SuperUserSection'
import UserDetailsSection from './UserFormSections/UserDetailsSection'
import UserRolesSection from './UserFormSections/UserRolesSection'
import UsersPageContext from './UsersPageContext'

type Props = {
  onDelete: (userEmail: string) => void
  onRestore: (userEmail: string) => void
}

const UserForm = ({ onDelete, onRestore }: Props) => {
  const { currentUser } = useContext(AuthenticationContext)
  const { state: user, isNewUser, isDeletedUser } = useContext(UsersPageContext)

  const [isRemoveUserModalOpen, setIsRemoveUserModalOpen] = useState(false)
  const [isRestoreUserModalOpen, setIsRestoreUserModalOpen] = useState(false)
  
  return (
    <>
      <Form layout='vertical' disabled={isDeletedUser}>
        <VSpace>
          <UserDetailsSection />
          <UserRolesSection />
          {
            currentUser?.isSuperUser && <SuperUserSection />
          }
          {
            !isNewUser && <PasswordUpdateSection />
          }
          {
            !isNewUser && <Row>
              <Col span={12}>
                <Button 
                  danger={!isDeletedUser}
                  type='primary'
                  style={{ backgroundColor: isDeletedUser ? green.primary : red.primary }}
                  onClick={() => isDeletedUser ? setIsRestoreUserModalOpen(true) : setIsRemoveUserModalOpen(true)} 
                  disabled={false}
                >
                  {isDeletedUser ? 'Restore User' : 'Remove User'}
                </Button>
              </Col>
            </Row>
          }
        </VSpace>
      </Form>
      <RemoveUserModal 
        isOpen={isRemoveUserModalOpen}
        onOk={() => {
          onDelete(user.email)
          setIsRemoveUserModalOpen(false)
        }}
        onClose={() => setIsRemoveUserModalOpen(false)}
      />
      <RestoreUserModal 
        isOpen={isRestoreUserModalOpen}
        onOk={() => {
          onRestore(user.email)
          setIsRestoreUserModalOpen(false)
        }}
        onClose={() => setIsRestoreUserModalOpen(false)}
      />
    </>
  )
}

export default UserForm
